import axios from "axios";
import { useEffect } from "react";

/** Check if a user is already authenticated - if yes, then redirect them to the dashboard */
export const useAuthenticatedRedirect = () => {
    useEffect(() => {
        const now = new Date();
        const redirectUrl = process.env.REACT_APP_LOGIN_APPEND_LOCATION + '/mbp/dashboard.aspx';
        axios.get(process.env.REACT_APP_LOGIN_API_ENDPOINT + `/session?t=${now.getTime()}`).then(() => {
            window.location.href = redirectUrl
        }).catch(() => {
            // no active session - do nothing
        });
    }, []);
};